import React, { useEffect, useState } from 'react';
import AuthHeader from "../UI/AuthHeader/AuthHeader";
import AuthSideMenu from "../UI/AuthSideMenu/AuthSideMenu";
import { useTheme } from "../UI/Theme/ThemeContext";
import { formatRelativeTime } from "../../utils/dates";
import useNotifications from "../../hooks/useNotifications";
import BubbleFloat from "../UI/BubbleFloat/BubbleFloat";

const NotificationsPage = () => {
  const { themeName } = useTheme();
  const [authMenuOpen, setAuthMenuOpen] = useState(false);
  const { items, markAllRead, markOneRead, refresh } = useNotifications({ limit: 50 });

  // On mount: load notifications, then mark all as read automatically
  useEffect(() => {
    (async () => {
      try {
        await refresh();
      } finally {
        // Idempotent: server will no-op for already-read items
        await markAllRead();
      }
    })();
  }, [refresh, markAllRead]);

  return (
    <div style={{ display: 'grid', minHeight: '100vh', width: '100%' }}>
      <AuthSideMenu opened={authMenuOpen} />
      <AuthHeader authMenuOpen={authMenuOpen} onClick={() => setAuthMenuOpen(v => !v)} />
      {/* Decorative floating bubbles background */}
      <BubbleFloat />

      <div style={{ width: '100%', margin: '3.5rem 0' }}>
        <div style={{ width: '100%', padding: '2.5% 2.5% 0', margin: '20px 0' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h2>Notifications</h2>
          </div>
        </div>

        <div style={{ width: '100%', padding: '0 2.5% 2.5%' }}>
          {items.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '2rem 0' }}>
              No notifications yet.
            </div>
          ) : (
            <div style={{ display: 'grid', gap: '10px', width: '100%' }}>
              {items.map(n => (
                <a key={n._id || String(n.createdAt)} href={n.url || '/'} onClick={() => markOneRead(n._id)} style={{ textDecoration: 'none', color: 'inherit' }}>
                  <div
                    style={{
                      border: themeName === 'dark' ? '1px solid rgba(255,255,255,0.08)' : '1px solid rgba(0,0,0,0.06)',
                      borderRadius: 12,
                      padding: '10px 12px',
                      background: themeName === 'dark' ? 'rgba(255,255,255,0.03)' : '#fff',
                      color: themeName === 'dark' ? '#E6EDF2' : '#0B1A21',
                      display: 'grid',
                      gridTemplateColumns: 'auto 1fr',
                      gap: 10,
                      alignItems: 'start'
                    }}
                  >
                    <div style={{ width: 8, height: 8, borderRadius: '50%', marginTop: 6, background: n.status === 'unread' ? '#d23b3b' : 'transparent' }} />
                    <div style={{ display: 'grid', gap: 4 }}>
                      <div style={{ fontWeight: n.status === 'unread' ? 700 : 600 }}>{n.title}</div>
                      {n.description && <div style={{ opacity: 0.9, fontSize: 14 }}>{n.description}</div>}
                      <div style={{ fontSize: 12, opacity: 0.7, alignSelf: 'end', justifySelf: 'end' }}>{formatRelativeTime(n.createdAt)}</div>
                    </div>
                  </div>
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationsPage;
